<template>
    <div class="p-5 lg:p-20">
      <div class="flex flex-col space-y-6 max-w-7xl mx-auto">
        <editable-headline field="flight_times" default="Flight times" :width="true"/>

        <div v-if="store.proposal.data?.flights && store.proposal.data.flights.length > 0" class="rounded-lg border flex divide-x text-sm border-button-teal">
          <div class="w-full p-5 border-button-teal" v-for="flight in store.proposal.data.flights">
            <p class="font-semibold flex items-center space-x-2 mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
              </svg>
              <span>{{ flight.origin }} - {{ flight.destination }}</span>
            </p>
            <p class="text-xs">{{ flight.agency }}</p>
            <formatted-time :date="flight.departure" class="text-xs" />
          </div>
        </div>
        <div v-else class="text-sm text-gray-500">
          No flights have been added yet.
        </div>
        <div class="sm:flex sm:justify-end">
          <button @click="showModal = true" class="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-2 mt-4 text-sm font-medium leading-4 text-white shadow-sm group-hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Edit flights
          </button>
        </div>
      </div>

    </div>

  <flight-modal :show="showModal" @close="showModal = false" @save="updateFlights" />
</template>

<script setup>
import FormattedTime from "@/ComponentsDeprecated/Time/FormattedTime";
import {useProposalOldStore} from "@/Stores/ProposalOld";
import FlightModal from "@/ComponentsDeprecated/Modal/Proposal/FlightModal";
import {ref} from "vue";
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";

const store = useProposalOldStore();

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
});
const showModal = ref(false);

function updateFlights(data) {
  props.form.data.flights = JSON.parse(JSON.stringify(data));
  showModal.value = false;
}
</script>
